import * as React from 'react'
import {Plan as PlanViewer} from '@wix/seating-viewer'
import {useViewBox} from '../../../../hooks/viewbox'
import {Controls} from './controls'
import {Legend} from './legend'
import s from './plan.scss'
import {PlanProps} from '.'

const MIN_ZOOM = 0.2
const MAX_ZOOM = 2
const ZOOM_STEP = 0.2
const placesStock = {}

export const Plan = ({plan, selectedSeat, selectedSeats, onSeatClick}: PlanProps) => {
  const {viewBox, zoom, cursor, changeSvgViewBox, onPointerDown, onPointerMove, onPointerUp} = useViewBox(plan)

  return (
    <div
      className={s.container}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      onPointerLeave={onPointerUp}
      onPointerMove={onPointerMove}
      style={{cursor}}
    >
      <PlanViewer
        placesStock={placesStock}
        currentlyClickedSeatId={selectedSeat?.id}
        selectedSeatIds={selectedSeats.map(seat => seat.id)}
        plan={plan as any}
        svgViewBox={viewBox}
        onSeatClick={onSeatClick}
      />
      <Legend />
      <Controls
        zoomOutDisabled={zoom === MIN_ZOOM}
        zoomInDisabled={zoom === MAX_ZOOM}
        onZoomIn={() => changeSvgViewBox({deltaScale: ZOOM_STEP})}
        onZoomOut={() => changeSvgViewBox({deltaScale: -ZOOM_STEP})}
      />
    </div>
  )
}
